<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
import { useSertStore } from "@/stores/sertStore";
import { useValidation } from "@/utils/useValidataion";
import { formatNumber } from "@/utils/functions";

const storeSert = useSertStore();

const props = defineProps({
    selectOptions: {
        type: Array,
    },
});

const dropdownRef = ref(null);
const dropdownRefHeight = ref(null);
const isOpen = ref(false);
const selectedId = ref(null);
const selectedTitle = ref('');

const { validation, isValid, isTouched, textError } = useValidation(selectedId);

const showDropdownList = () => {
    isOpen.value = !isOpen.value;
    dropdownRefHeight.value = dropdownRef.value?.offsetHeight || 80;
};

const changeValueSelect = (optionId, optionTitle) => {
    selectedId.value = optionId;
    selectedTitle.value = formatNumber(optionTitle);
    isOpen.value = false;
    isTouched.value = true;
    validation("select");
    storeSert.updateCheckedItem("select", "id", selectedId.value);
    storeSert.updateCheckedItem("select", "title", optionTitle);
};

const closeDropdownOnClickOutside = (event) => {
    if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        isOpen.value = false;
    }
};

watch(
	() => storeSert.checkedItems.select.title,
	(newVal) => {
        
		if (newVal !== selectedTitle.value) {
			selectedTitle.value = formatNumber(newVal) ?? "";
		}
	},
	{ immediate: true }
);

onMounted(() => {
    document.addEventListener("click", closeDropdownOnClickOutside);
    if(!storeSert.checkedItems.select.title) {
        selectedTitle.value = 'Выберите номинал сертификата'        
    }
});

onUnmounted(() => {
    document.removeEventListener("click", closeDropdownOnClickOutside);
});
</script>
<template>
    <div class="dropdown">
        <label :class="['dropdown-label input', { '--visible': isOpen }]" ref="dropdownRef">
            <span class="input__title">Выберите номинал</span>
            <div class="dropdown__inner-button">
                <input
                    v-model="selectedTitle"
                    @click="showDropdownList"
                    :class="[
                        'dropdown__button input__field',
                        isTouched && (isValid ? 'valid' : 'not-valid'),
                    ]"
                    :placeholder="selectedTitle"
                    @blur="validation('select')"
                    @focus="validation('select')"
                    readonly
                />
            </div>
        </label>
        <Transition>
            <div
                :class="['dropdown__list']"
                v-if="isOpen"
                :style="{ top: dropdownRefHeight + 5 + 'px' }"
            >
                <ul class="dropdown__list-scroll list-scrollbar">
                    <li
                        v-for="{ price, id } in props.selectOptions"
                        :key="id"
                        @click="changeValueSelect(id, price)"
                        class="dropdown__list-item"
                        :data-value="id"
                    >
                        {{ formatNumber(price) }}
                    </li>
                </ul>
            </div>
        </Transition>
    </div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from {
    opacity: 0;
    transform: translate(0%, 20px);
}
.v-leave-to {
    opacity: 0;
    transform: translate(0%, 20px);
}

.dropdown {
    position: relative;
}

.dropdown__button {
    position: relative;
    display: block;
    width: 100%;
    cursor: pointer;

    overflow: hidden;
    text-overflow: ellipsis;    
}

.dropdown__inner-button {
    position: relative;
    &::after {
        content: "";
        position: absolute;
        top: 50%;
        right: 28px;
        transform: translateY(-50%) rotateX(0deg);
        background-image: url("@/assets/img/icons/select_icon.svg");
        background-repeat: no-repeat;
        background-position: 0px 0px; /* x y*/
        background-size: auto; /* w h*/
        width: 24px;
        height: 24px;
        pointer-events: none;
        transition: var(--transition) ease-in;
        @media (max-width: vars.$x480) {
            right: 10px;
        }
    }

    &.--visible {
        &::after {
            transform: translateY(-50%) rotateX(180deg);
        }
    }
}

.dropdown__list {
    position: absolute;
    left: 0;
    top: 80px;

    margin: 0;
    list-style-type: none;
    background: rgb(43, 42, 42);
    overflow: hidden;
    width: 100%;
    z-index: 2;
    @media (max-width: vars.$x480) {
        top: 55px;
    }
}

.dropdown__list-item {

    font-family: var(--font-family);
    font-weight: 400;
    font-size: 2rem;
    line-height: 160%;
    color: var(--text-inverse-100);
    margin: 0;
    padding: 0;
    border-bottom: 0px;
    padding: 1.8rem 2.4rem;
    cursor: pointer;
    @media (max-width: vars.$x480) {
        padding: 2rem;
        font-size: 16px;
    }
	&:not(:last-child) {
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	}
}

.dropdown__list-item:hover {
    background: rgba(136, 136, 136, 0.26);
}

.dropdown__input-hidden {
    display: none;
}
.dropdown__list-scroll {
    height: 30rem;
}

</style>
